var _rect, _rect2, _rect3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUzbFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.05408,
    width: 20,
    height: 4,
    fill: "#4299EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6.05408,
    width: 20,
    height: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 10.0541,
    width: 20,
    height: 4,
    fill: "#50B63F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31738 18.0541H9.92871V23.7201C9.92871 24.3724 9.78809 24.9213 9.50684 25.3666C9.22559 25.808 8.84277 26.142 8.3584 26.3685C7.87402 26.5912 7.32324 26.7025 6.70605 26.7025C6.08105 26.7025 5.52441 26.5912 5.03613 26.3685C4.54785 26.142 4.16504 25.808 3.8877 25.3666C3.61035 24.9213 3.47168 24.3724 3.47168 23.7201V18.0541H5.08301V23.7201C5.08301 24.1185 5.14941 24.4447 5.28223 24.6986C5.41504 24.9486 5.60254 25.1342 5.84473 25.2552C6.08691 25.3763 6.37402 25.4369 6.70605 25.4369C7.04199 25.4369 7.3291 25.3763 7.56738 25.2552C7.80957 25.1342 7.99512 24.9486 8.12402 24.6986C8.25293 24.4447 8.31738 24.1185 8.31738 23.7201V18.0541Z",
    fill: "#4299EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5283 25.3197V26.5853H10.54V25.3197H16.5283ZM16.417 18.9974L11.2021 26.5853H10.0947V25.6185L15.333 18.0541H16.417V18.9974ZM15.8428 18.0541V19.3256H10.1123V18.0541H15.8428Z",
    fill: "#4299EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzbFlag);
export default __webpack_public_path__ + "static/media/uzb-flag.e9b7926027455a9cf569544060cb0b9a.svg";
export { ForwardRef as ReactComponent };